export const KYC_POLLING_STATUS = {
  PENDING: "Pending",
  READY: "Ready",
  FAILED: "Failed",
};

export const KYC_STEP_TYPE = {
  POST_KYC: 1,
  POST_CONTRACT: 2,
  ORDER_STATUS: 3,
};

export const MAX_POLL_COUNT = 60; // Maximum 5 minutes of polling (60 * 5 seconds)

export const KYC_SUCCESS_PATTERNS = [
  "kyc_success",
  "verification_complete",
  "contract_signed",
];
export const LOADER_TEXT = {
  Please_wait: "Please wait",
  Verifying: "Verifying",
};
export const KYC_FAILURE_PATTERNS = ["kyc_error", "verification_failed"];

export const KYC_MESSAGE_TYPES = {
  SUCCESS: "kyc_success",
};

export const bulletPoints = [
  {
    title: "Agreement in place:",
    description:
      "A verified contract outlines the services and ensures mutual clarity.",
  },
  {
    title: "Clear service info:",
    description: "All terms and offerings are shared upfront — no surprises.",
  },
  {
    title: "Your data is safe:",
    description:
      "Aadhaar and personal info are securely encrypted and privacy-compliant.",
  },
];
